module.exports = __webpack_public_path__ + "static/media/setup-feedback.aa9f7baf.svg";